/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export abstract class StatefulComponent<T> {
    private _state: T;

    get state(): T {
        return this._state ?? {} as T;
    }

    storeState(state?: Partial<T>): void {
        this._state = {...this._state, ...state};
    }
}
